import { slug } from './content/helpers';
import { z } from 'zod';
import { COUNTRY_CODES } from '../constants';

export const citySchema = z
  .object({
    id: z.number().int().positive().optional(),
    name: z.string().min(1, 'Name is required').max(100),
    country: z.enum(COUNTRY_CODES as [string, ...string[]]),
    state: z.string(),
    slug: slug,
  })
  .superRefine((data, ctx) => {
    if (data.country === 'US' && !data.state) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'State is required for US cities',
        path: ['state'],
      });
    }
  });

export type CityInput = z.infer<typeof citySchema>;
